export default{
  '1': 'Failed to acquire order information.',
  '2': 'Failed to acquire the QR code for payment.',
  '3': 'Going to Paypal, please wait.',
  '4': 'Please fill in.',
  '5': 'Invoice ready.',
  '6': 'Invoice ready.',
  '7': ' cannot be blank.',
  '8': 'Please enter a correct Email address.',
  '9': 'Submit successfully',
  '10': 'Incorrect contact information, please confirm.',
  '11': 'Network busy, please try later.',
  '12': 'Your message is well received, we will come back to you soonest.',
  '13': 'Failed to acquire the camera detail.',
  '14': 'Cannot delete the last item.',
  '15': 'Are you sure to delete?',
  '16': 'Please agree our terms first.',
  '17': 'Please save the invoice information.',
  '18': 'Please save the delivery information.',
  '19': 'Please complete the delivery information.',
  '20': 'Please complete the invoice information.',
  '21': 'Please enter the 18-digits tax number.',
  '22': 'Please enter a correct mobile number.',
  '23': 'Signed up successfully. Log in now?',
  '24': 'Password reset. Please re-log in.',
  '25': 'No record found.',
  '26': 'Are you sure to unbind the current camera?',
  '27': 'Incorrect image format. Please upload again.',
  '28': 'Your cloud storage is used up, please delete scenes or expand the storage. ',
  '29': 'Illegal mobile number',
  '30': 'Please re-log in.',
  '31': 'Password digits must not be less than 8 digits',
  '32': 'Password changed successfully',
  '33': 'Unbind successfully',
  '34': 'Fail',
  '35': 'User name cannot be blank.',
  '36': 'The type of picture uploaded is not correct, please upload again.',
  '37': 'Deleted successfully',
  '38': 'Delete failed',
  '39': 'The item was added to the shopping cart successfully',
  '40': 'Please login to your user account and renew the package.',
  '41': 'Log in',
  '42': 'Downgrading process is currently not supported. You can renew or upgrade the package.',
  '43': 'Please bind this camera to a user account before expanding the storage.',

  '4007': 'User name doesn\'t exist.',
  '4010': 'The bound camera doesn\'t exist.',
  '4011': 'The camera is already bound.',
  '4012': 'Incorrect user name or password.',
  '7001': 'Title contains sensitivie words.',
  '7002': 'Content contains sensitivie words.',
  '6001': 'Same MAC address.',
  '6002': 'Refund value over top-up value.',
  '6003': 'The camera doesn\'t exist.',
  '6004': '表示相机的点数超过了10万',
  '6006': 'A camera can only be bound to one account.',
  '6009': 'data.fdage file doesn\'t exist.',
  '6010': 'This SN is already bound.',
  '3001': 'Key parameters are missing.',
  '3002': 'Abnormal request!',
  '3003': 'Illegal request!',
  '3004': 'Please re-log in.',
  '3005': 'Verification code expired.',
  '3006': 'Incorrect verification code.',
  '3007': 'User name already exists.',
  '3008': 'The mobile number is already registered.',
  '3009': 'The password you typed don\'t match.',
  '3010': 'Incorrect user name length. (2-11 characters)',
  '3011': 'Password must contain English case and numbers, 8-16 characters. ',
  '3012': 'User name contains sensitive words.',
  '3013': 'Incorrect format of mobile number.',
  '3014': 'Incorrect user name or password.',
  '3015': 'User doesn\'t exist.',
  '3016': 'You have no access. Please contact the administrator.',
  '3017': 'Empty file',
  '3018': 'The file to upload or to use doesn\'t exist.',
  '3019': 'Incorrect format of Email address.',
  '8001': 'Order doesn\'t exist.',
  '8002': 'Payment failure',
  '5001': 'Empty modeldata.json',
  '5002': 'Empty order value',
  '5003': 'Empty guideSid or order value',
  '5004': 'Empty guideSid or guideName value',
  '5005': 'Empty scene',
  '5006': 'Insufficient balance',
  '5007': 'Non 4D KanKan Pro scene',
  '5008': 'The scene is archived and cannot be deleted.',
  '5009': 'The scene is deleted.',
  '5010': 'The scene doesn\'t belong to this camera.',
  '5011': 'Create',
  '5012': 'Abnormal data',
  '5013': 'User name of the scene is empty.',
  '5014': 'The user has no access to edit this scene.',
  '5015': 'The scene doesn\'t belong to the logged in account.',
  '5016': 'Incorrect linked scene'
}



// WEBPACK FOOTER //
// ./src/store/language/en/toast.js